import { render, staticRenderFns } from "./Flamingo.vue?vue&type=template&id=67e14bf7&scoped=true"
import script from "./Flamingo.vue?vue&type=script&lang=js"
export * from "./Flamingo.vue?vue&type=script&lang=js"
import style0 from "./Flamingo.vue?vue&type=style&index=0&id=67e14bf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e14bf7",
  null
  
)

export default component.exports